import { ChangeEvent, FC, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, Paper, Tab, Tabs } from '@material-ui/core';
import { useStylesSecond } from './styles';
import TabPanel from 'components/TabPanel';
import { MicrosoftInfoTable } from './MicrosoftInfoTable';
import { MicrosoftSyncUser } from './MicrosoftSyncUser';
import { MicrosoftSyncGroup } from './MicrosoftSyncGroup';
// import { MicrosoftSyncDepartment } from './MicrosoftSyncDepartment';
import { useLocation } from 'react-router-dom';
import { useStore } from 'hooks/useRootStore';
import { useQuery } from 'react-query';
import AppTimeline from '../GoogleTable/AppTimeline';
function useQuer() {
  return new URLSearchParams(useLocation().search);
}
export const MicrosoftTable: FC = observer(() => {
  const classes = useStylesSecond();
  function a11yProps(index: string) {
    return {
      id: `wrapped-tab-${index}`,
      'aria-controls': `wrapped-tabpanel-${index}`,
    };
  }
  const query = useQuer();
  const queryValue = query.get('value');
  const defaultTabs = (Array.isArray(queryValue) ? queryValue[0] : queryValue) ?? 'one';
  const [value, setValue] = useState<string>(defaultTabs);
  const {
    ldapStore: { getGoogleTimeline },
    notificationStore: { openNotification },
  } = useStore();
  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
  };

  const microsofttimelineReq = useQuery(['microsoftTimeline', 'apps'], () => getGoogleTimeline('microsoft'), {
    enabled: value === 'four',
    onError: () => {
      openNotification('error', "Can't get microsoft timeline");
    },
  });

  return (
    <Grid item xl className={classes.tabsPanel}>
      <Paper className={classes.tabsPaper}>
        <Tabs
          value={value}
          className={classes.tabs}
          TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
          onChange={handleChange}
        >
          <Tab value='one' wrapped label={<span>INFO</span>} {...a11yProps('one')} className={classes.label} />
          <Tab value='two' wrapped label={<span>Users</span>} {...a11yProps('two')} className={classes.label} />
          <Tab value='three' wrapped label={<span>Groups</span>} {...a11yProps('three')} className={classes.label} />
          <Tab value='four' wrapped label={<span>Timeline</span>} {...a11yProps('four')} className={classes.label} />
        </Tabs>
        <div className={classes.tabBox}>
          <TabPanel value={value} index='one'>
            <MicrosoftInfoTable />
          </TabPanel>
          <TabPanel value={value} index='two'>
            <MicrosoftSyncUser />
          </TabPanel>
          <TabPanel value={value} index='three'>
            <MicrosoftSyncGroup />
          </TabPanel>
          <TabPanel value={value} index='four'>
            <AppTimeline
              header='microsoft'
              events={microsofttimelineReq.data || []}
              loading={microsofttimelineReq.isLoading}
            />
          </TabPanel>
        </div>
      </Paper>
    </Grid>
  );
});
